var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToolsIconSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        opacity: 0;\n      }\n\n      .cls-2 {\n        fill: #3e76f6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_45445",
    "data-name": "\\u7EC4 45445",
    transform: "translate(-1079 -1115)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_5963",
    "data-name": "\\u77E9\\u5F62 5963",
    className: "cls-1",
    width: 20,
    height: 20,
    transform: "translate(1079 1115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_37296",
    "data-name": "\\u8DEF\\u5F84 37296",
    className: "cls-2",
    d: "M76.793,3.842h-.427a.659.659,0,0,1-.616-.522,4.084,4.084,0,0,0-8,0,.659.659,0,0,1-.615.522h-.046a4.269,4.269,0,0,0-4.15,4.38v5.334a4.269,4.269,0,0,0,4.15,4.38h9.7a4.268,4.268,0,0,0,4.149-4.38V8.222a4.268,4.268,0,0,0-4.149-4.38m-7.2-1.022a2.556,2.556,0,0,1,4.319,0,.664.664,0,0,1-.534,1.022H70.125a.663.663,0,0,1-.533-1.022m7.475,7.485a2.5,2.5,0,0,1-2.611,2.187A2.38,2.38,0,0,1,73.1,11.94l-4.076,2.219a1.225,1.225,0,0,1-1.709-.611,1.355,1.355,0,0,1,.639-1.783L72.17,9.856c0-.049-.007-.1,0-.145A2.518,2.518,0,0,1,74.8,7.292a2.319,2.319,0,0,1,1.082.365l0,0a.3.3,0,0,1-.028.5l-.917.457a1.033,1.033,0,0,0-.462,1.325.951.951,0,0,0,1.3.489l.9-.451a.276.276,0,0,1,.388.286c0,.015,0,.027,0,.036",
    transform: "translate(1017.058 1115.928)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsIconSelected);
export default __webpack_public_path__ + "static/media/tools-icon-selected.44cb8da2a8ddb93d94731a73f55a1b21.svg";
export { ForwardRef as ReactComponent };